var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getData, updateData, createData, } from "../dataAccess";
//============================================================================================================
//                                          ADMINISTRATIVE USERS
// Returns an ApiResponse which has a data object of type T in this case AdminUserModel[]
//============================================================================================================
// Get all administrative users
export const getAdminUsers = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = `AdminUser/`;
    return getData(url);
});
// Create a new administrative user
export const createAdminUser = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `AdminUser/create`;
    return createData(url, item);
});
// Update an existing administrative user's username/email
export const updateAdminUser = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `AdminUser/update`;
    return updateData(url, item);
});
// Delete (archive) an administrative user
export const deleteAdminUser = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `AdminUser/AdminUser-delete`;
    return updateData(url, item);
});
// Reset an administrative user's password
export const resetAdminUserPassword = (id, newPassword) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `AdminUser/reset-password`;
    return updateData(url, { id, newPassword });
});
